module.exports = __webpack_public_path__ + "img/propeties.16f2a6f6.png";